import React from "react";
import RegisterForm from "../components/user/Register";

function Register() {
  return (
    <div className="page p-1">
      <RegisterForm />
    </div>
  );
}

export default Register;
